////////gmap_file////////
var geocodeur;
var infowindow = null;
var maCarte;
var markers = [];
var clusterer;
var type_call = '';
var markersArray = new Array();
var date = new Date();
var t_address;
var horaire_txt = '';
// Should be a constants but are variables for compatibility reasons
var search_exceptions = ['nancy', 'bayonne', 'macon', 'le cres'];
var zipcode_rex = new RegExp("^[0-9]+$");

var txt_store_locator_product_available = Translator.translate('store_locator_product_available');
var txt_store_locator_product_unavailable = Translator.translate('store_locator_product_unavailable');
var txt_according_to_stock = Translator.translate('according_to_stock');
var txt_on_web = Translator.translate('on_web');
var txt_available = Translator.translate('available');
var txt_available_mag = Translator.translate('available_mag');
var txt_horaire_shop = Translator.translate('txt_horaire_shop');

var store_open_until_3a = Translator.translate("store_open_until_3a");
var store_open_until_3b = Translator.translate("store_open_until_3b");
var store_open_until_3d = Translator.translate("store_open_until_3d");
var store_open_until_2 = Translator.translate("store_open_until_2");

var clustererRenderer = {
    render: function ({ count, position }) {
        // create marker using a div

        const clusterMarker = document.createElement('div');
        clusterMarker.style.width = '52px';
        clusterMarker.style.height = '52px';
        clusterMarker.style.backgroundImage = 'url(' + clusterImg + ')';
        clusterMarker.style.backgroundSize = 'cover';
        clusterMarker.style.color = 'white';
        clusterMarker.style.display = 'grid';
        clusterMarker.style.placeItems = 'center';
        clusterMarker.style.fontSize = '11px';
        clusterMarker.style.fontWeight = 'bold';
        clusterMarker.style.textShadow = '0 0 1px black';
        clusterMarker.style.fontFamily = 'pragmatica, sans-serif';
        clusterMarker.style.textAlign = 'center';
        clusterMarker.textContent = count;

        return new google.maps.marker.AdvancedMarkerElement({
            position,
            content: clusterMarker,
            zIndex: 1000 + count,
        });
    },
}

// Initialisation de la premiere carte google map
function initialize(no_loading) {

    var inputAutocompleteId = 'search_cp';
    var searchElem = document.getElementById(inputAutocompleteId);
    var urlHref = window.location.href;
    var url = new URL(urlHref);
    var search_params = new URLSearchParams(url.search);
    var selected_pays_code;
    if (!search_params.has('country_id')) { // Si pas de paramètre country_id dans l'url (usage sur Pierre Marcolini), on prend le pays sélectionné dans le select
        selected_pays_code = $("#search_pays").find(":selected").attr('data-code');
    } else {
        var countryId = search_params.get('country_id');
        selected_pays_code = $("#search_pays").find("option[data-id='" + countryId + "']").attr('data-code');
        selected_pays_val = $("#search_pays").find("option[data-id='" + countryId + "']").val();
        // Select the country in the dropdown if it exists
        $('#search_pays').val(selected_pays_val);
    }

    var option = {
        types: ['geocode']
    };

    var autocomplete = new google.maps.places.Autocomplete((searchElem), option);
    // Change autocomplete attribute to prevent browser from autofilling
    setTimeout(() => {
        searchElem?.setAttribute('autocomplete', 'new-password');
    }, 200);

    // Pour le changement d'adresse de l'autocomplete de google on va charger les informations
    google.maps.event.addListener(autocomplete, 'place_changed', function () {

        geocodeAdresse();
    });

    $('.wrapper_retailers_map').animate({
        opacity: 1
    }, 600);

    t_address = Translator.translate('default_address');

    $("#search_pays").on('change', function () {
        var searchElem = $('#search_cp');
        selected_pays_code = $(this).find(":selected").attr('data-code');

        if (selected_pays_code === undefined || selected_pays_code === '') {
            autocomplete.setComponentRestrictions();
        } else {
            autocomplete.setComponentRestrictions({
                country: selected_pays_code
            });
            searchElem.val('');
        }

        geocodeAdresse();
        type_call = 'select_pays';
    });

    geocodeur = new google.maps.Geocoder();

    if ($("#retailers_map").length) {

        var latlng = new google.maps.LatLng(46.864716, 2.22);
        var myOptions = {
            zoom: 5,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapId: google_map_id,
        };

        if (typeof MapsProviderService != "undefined") {
            var mapHtml = document.getElementById('retailers_map');
            maCarte = MapsProviderService.initSearchShopPage(mapHtml);
        } else {
            maCarte = new google.maps.Map(document.getElementById("retailers_map"), myOptions);
        }

        markers = [];
    }

    if (typeof(no_loading)=='undefined') {

        geocodeAdresse();
    }
}

function resetSelectedCountry() {

    $('#search_pays').find('option').removeAttr('selected');
    $('#search_pays').find('option:first').attr('selected', 'selected');
    $('#search_pays').val('');
}

$(document).on('click', '.select_filtre', function () {

    displayLoader('hide');
    rechercheProximite();
});

function get(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

function initSearch() {

    if ($("#retailers_map").length) {

        var pays_id = $("#search_pays").find(":selected").data('id');
        var myOptions = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapId: google_map_id,
        };
        // permet de centrer la carte sur le pays de recherche
        var latlng = new google.maps.LatLng(46.864716, 2.22);// defaut France
        switch(pays_id) {
            case 3: // Belgique
                latlng = new google.maps.LatLng(50.850335, 4.36);
                break;
            case 4: // SUisse
                latlng = new google.maps.LatLng(46.924143, 8.03);
                break;
            case 6: // Luxembourg
                latlng = new google.maps.LatLng(49.775125, 6.08);
                break;
        }

        mcOptions = {
            gridSize: 80,
        };

        if (typeof MapsProviderService != "undefined") {
            var mapHtml = document.getElementById('retailers_map');
            maCarte = MapsProviderService.initSearchShopPage(mapHtml);
            maCarte.setCenter(latlng);
            maCarte.setZoom(5);
        } else {
            maCarte = new google.maps.Map(document.getElementById("retailers_map"), myOptions);
            maCarte.setCenter(latlng);
            maCarte.setZoom(5);
        }

    }
    document.getElementById('list-store').innerHTML = '';
}

var resetResults;
var showAllStoreBtn;
// Vrai quand la saisie est un pays : la recherche porte alors sur le pays et non sur un rayon
var searchOnCountry = false;

/**
 * Positionne le select #search_pays sur le pays renvoyé par le géocodeur.
 *
 * Une saisie de type pays ("Suisse", "Belgique"...) est géocodée sur le centroïde du pays :
 * la recherche de proximité qui suit perd alors tous les magasins situés au delà du rayon.
 * Le filtre pays, lui, remonte la totalité des magasins du pays.
 *
 * @param   {Object}  geocodeResult  résultat du géocodeur Google
 * @returns {boolean} true si la recherche doit porter sur le pays plutôt que sur un rayon
 */
function selectCountryFromGeocode(geocodeResult) {

    var searchPays = $('#search_pays');

    // Sur la fiche produit mobile les paramètres pays ne sont pas transmis à la recherche
    var isPaysRequestDisabled = $('body.product_page.mobile').length
        && typeof removePaysRequest !== 'undefined'
        && removePaysRequest;

    if (!searchPays.length || isPaysRequestDisabled) {

        return false;
    }

    if (!geocodeResult.types || geocodeResult.types.indexOf('country') === -1) {

        return false;
    }

    var countryCode = '';

    $.each(geocodeResult.address_components, function (index, component) {

        if (component.types.indexOf('country') !== -1) {

            countryCode = component.short_name;
        }
    });

    var option = searchPays.find('option[data-code="' + countryCode + '"]');

    // Pays sans magasin sur le site : on conserve la recherche de proximité
    if (!option.length) {

        return false;
    }

    searchPays.val(option.val());

    return true;
}

// Fonction utilisée quand l'utilisateur indique un lieu
function geocodeAdresse() {

    // On affiche le loader
    displayLoader('hide');

    resetResults = true;
    showAllStoreBtn = false;
    searchOnCountry = false;

    var adresse = '';

    adresse = document.getElementById("search_cp").value.trim();

    // Cas special pour nancy il nous envoie aux US!!!
    if (search_exceptions.includes(adresse)) {

        adresse += ' france';
    }

    if (zipcode_rex.test(adresse)) {
        adresse += ', France';
        document.getElementById("search_cp").value += ', France';
    }

    if (geocodeur != 'undefined') {
        geocodeur = new google.maps.Geocoder();
    }

    if (adresse == '') {
        adresse = get('search_cp');
        if (typeof adresse == 'undefined') {
            adresse = '';
        }
    }

    if (document.getElementById('produit_id') && document.getElementById('produit_id').value !== '') {
        //adresse += '&produit_id=' + encodeURIComponent(document.getElementById('produit_id').value);
    }

    geocodeur.geocode({
        address: adresse
    }, function (results, status) {

        // Si l'utilisateur ne saisit rien on se remet à la position initiale (on remet la premiere carte et tous les magasins)
        if (adresse === '') {

            if ($("#retailers_map").length) {

                initSearch();
                clusterer = new markerClusterer.MarkerClusterer({
                    map: maCarte,
                    markers: markers,
                    options: mcOptions,
                    renderer: clustererRenderer
                });

                boundChanched(maCarte, markersArray);
                markers = [];
            }

            // On va rechercher tous les magasins
            rechercheProximite();

        } else if (type_call == 'select_pays') {
            rechercheProximite();
        } else if (status == google.maps.GeocoderStatus.OK) {

            /* var pos = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
            };
            rechercheProximite(pos); */
            searchOnCountry = selectCountryFromGeocode(results[0]);

            rechercheProximite(results[0]);
        } else {
            displayLoader('show');
            alert(adresse + ' ' + Translator.translate('txt_introuvable'));
        }
    });
}

function geolocalisation() {

    resetResults = true;
    showAllStoreBtn = false;
    searchOnCountry = false;

    if ($('#search_pays').length) {

        resetSelectedCountry();
    }

    if ($('#search_cp').val() !== '') {

        $('#search_cp').val('');
    }

    navigator.geolocation.getCurrentPosition(function (position) {
    // On affiche le loader
        displayLoader('hide');
        var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };

        // Dnas rechercehProximite on affiche le loader
        rechercheProximite(pos);
    });
}

// Recherche des differents magasins selon les criteres selectionnes
function rechercheProximite(latlng, not_init) {
    resetResults = true;

    // Pour les filtres
    var param = '';
    // Pour la recherche
    var param_sup = '';

    // On recupere toutes les checkbox cochées pour les filtres
    $("input[name='filtres[]']:checked").each(function () {
        param += '&filtres[]=' + $(this).val();
    });

    var adresse = document.getElementById('search_cp').value;

    if (adresse.substr(0, 20) === Translator.translate('default_address_begin')) {
        adresse = '';
    }

    param_sup += 'search=' + adresse + param;

    // desactive les pays de la requête si c'est la page produit en mobile
    if (!($('body.product_page.mobile').length && removePaysRequest)) {
        param_sup += '&pays=' + encodeURIComponent(document.getElementById('search_pays').value);
        param_sup += '&pays_id=' + $("#search_pays").find(":selected").data('id');
    }

    // utile pour les bornes d'hesperide ou autres
    if (document.getElementById('pdv') && document.getElementById('pdv').value !== '') {
        param_sup += '&pdv=' + encodeURIComponent(document.getElementById('pdv').value);
    }

    if (document.getElementById('produit_id') && document.getElementById('produit_id').value !== '') {
        param += '&produit_id=' + encodeURIComponent(document.getElementById('produit_id').value);
        param_sup += '&produit_id=' + encodeURIComponent(document.getElementById('produit_id').value);
    }

    // Cas specifique catalogue
    if (document.getElementById('cataloguesWrapper') && typeof(magasin_filtre_nom) && magasin_filtre_nom!='') {
        param += '&magasin_filtre_nom=' + magasin_filtre_nom;
        param_sup += '&magasin_filtre_nom=' + magasin_filtre_nom;
    } else {
        if (document.getElementById('magasin_filtre_nom')) {
            if (document.getElementById('magasin_filtre_nom').getAttribute('filtre_nom')) {
                param += '&magasin_filtre_nom=' + document.getElementById('magasin_filtre_nom').getAttribute('filtre_nom');
                param_sup += '&magasin_filtre_nom=' + document.getElementById('magasin_filtre_nom').getAttribute('filtre_nom');
            } else {
                param += '&magasin_filtre_nom=' + document.getElementById('magasin_filtre_nom').value;
                param_sup += '&magasin_filtre_nom=' + document.getElementById('magasin_filtre_nom').value;
            }
        }
    }

    type_call = 'auto';

    var lat_exact;
    var lng_exact;
    var requeteRecherche;
    var retailers_map = $('#retailers_map');
    retailers_map.css('width', '100%');
    if (typeof (latlng) != 'undefined') {
        type_call = 'button';

        if (latlng.coords || (latlng.lat && latlng.lng)) {

            if (retailers_map.length) {

                var myOptions = {
                    mapId: google_map_id,
                };
                var mcOptions = {
                    gridSize: 80,
                };

                if (typeof MapsProviderService != "undefined") {

                    var mapHtml = document.getElementById('retailers_map');
                    maCarte = MapsProviderService.initSearchShopPage(mapHtml);
                } else {

                    maCarte = new google.maps.Map(document.getElementById("retailers_map"), myOptions);
                    clusterer = new markerClusterer.MarkerClusterer({
                        map: maCarte,
                        markers: markers,
                        options: mcOptions,
                        renderer: clustererRenderer
                    });
                }

                boundChanched(maCarte, markersArray);
                markers = [];
            }

            if (latlng.coords) {
                lat_exact = latlng.coords.latitude;
                lng_exact = latlng.coords.longitude;
            } else {
                lat_exact = latlng.lat;
                lng_exact = latlng.lng;
            }

            var requeteRecherche = path_relative_root + 'ajax_generate_xml_map.php?lat=' + lat_exact + '&lng=' + lng_exact + '&' + param_sup;
        } else if (searchOnCountry) {

            // Recherche sur le pays entier : pas de lat/lng, donc pas de filtre de distance
            requeteRecherche = path_relative_root + 'ajax_generate_xml_map.php?' + param_sup;
        } else {

            requeteRecherche = path_relative_root + 'ajax_generate_xml_map.php?lat=' + latlng.geometry.location.lat() + '&lng=' + latlng.geometry.location.lng() + '&' + param_sup;
        }
    } else {

        requeteRecherche = path_relative_root + 'ajax_generate_xml_map.php?' + param_sup;
    }

    no_result = false;
    // Pour ne le charger qu'une seul fois
    horaire_txt = Translator.translate('horaires_map');
    close_txt = Translator.translate('close2');

    // On effectue la requete suivant les filtres indiques
    if (typeof not_init == undefined || !not_init) {
        initSearch();
    }
    downloadUrl(requeteRecherche, '100km', type_call, function (doc) {

        var xml = doc.responseXML;
        var marqueurs = xml.documentElement.getElementsByTagName("marqueur");
        clearOverlays();

        var listeLaterale = document.getElementById('list-store');
        if (document.getElementById('search_cp').value !== '') {
            listeLaterale.innerHTML = '';
        }
        // S'il la recherche n'aboutit a aucun resultat on met la carte sur la position initiale et on affiche qu'aucun resultat n'a ete trouve
        if (marqueurs.length === 0) {
            $(".search-result").hide();
            displayLoader('show');
            listeLaterale.innerHTML = '<span class="no_result">' + Translator.translate('txt_no_near_shop') + '</span>';

            if (maCarte) {

                var latlng = new google.maps.LatLng(46.864716, 2.22);
                maCarte.setCenter(latlng);
                maCarte.setZoom(5);
            }

            // SI on a fait une recherche on affiche la liste
            if (type_call == 'button') {
                // S'il la recherche n'aboutit a aucun resultat on met la carte sur la position initiale et on affiche qu'aucun resultat n'a ete trouve
                displayLoader('show');
                $('#store-nbr').html('');
                document.getElementById('list-store').innerHTML = '<span class="no_result">' + Translator.translate('txt_no_near_shop') + '</span>';
                $('.section-list-store').show();
            }
            return;
        } else if (type_call === 'button') {
            $('.section-list-store').show();

            if($('.wrapper_retailers_map').length && !$('.product_page.mobile').length){
                window.scrollTo(0, ($('.wrapper_retailers_map').offset().top - $("#site_head_wrap").height() ))
            }
        }
        var query = '';
        if ($("#search_cp").val()) {
            query = '?search_cp=' + encodeURI($("#search_cp").val());
        }
        if (typeof lat_exact !== 'undefined' && typeof lng_exact !== 'undefined') {
            if (query != '') {
                query += '&';
            } else {
                query = '?';
            }
            query += 'lat=' + lat_exact + '&lng=' + lng_exact;
        }
        $(".search-result").show();

        // On va creer les marqueurs puis la liste laterale qui est une correspondance des marqueurs suivant la proximite de l'adresse saisie
        var rectangleMarqueurs = new google.maps.LatLngBounds();
        // Récupérer de la date de l'utilisateur pour vérifier si le magasin est encore ouvert
        var date = new Date();
        var hours = date.getUTCHours();
        var minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

        for (var i = 0; i < marqueurs.length; i++) {
            var storeTimezoneOffset = 0;
            var storeTimezoneOffsetRaw = marqueurs[i].getAttribute("magasin_timezone_offset");
            if (storeTimezoneOffsetRaw !== undefined && !isNaN(parseInt(storeTimezoneOffsetRaw))) {
                storeTimezoneOffset = parseInt(storeTimezoneOffsetRaw);
            }
            var time = ((hours + storeTimezoneOffset) < 10 ? "0" : "") + (hours + storeTimezoneOffset) + minutes;

            var nom = marqueurs[i].getAttribute('nom');
            var adresse = marqueurs[i].getAttribute('adresse');
            var ville = marqueurs[i].getAttribute('ville');
            var cp = marqueurs[i].getAttribute('cp');
            var pays = marqueurs[i].getAttribute('pays');
            var magasinId = marqueurs[i].getAttribute('magasin_id');
            var stock = marqueurs[i].getAttribute('stock');
            var stock_quantity = marqueurs[i].getAttribute('stock_quantity');
            var stockStatus = marqueurs[i].getAttribute('stock-status');
            var clientId = marqueurs[i].getAttribute('client_id');
            var favorite = marqueurs[i].getAttribute('favorite');
            var beContacted = marqueurs[i].getAttribute('contact_by_store');

            var picture_filtre = new Array();
            if (marqueurs[i].hasChildNodes()) {
                var filters = marqueurs[i].childNodes;
                for (var j = 0; j < filters.length; j++) {
                    picture_filtre.push(filters[j].getAttribute('picture_filtre'));
                }
            }

            if (cp.length === 4 && pays === 'France') {
                cp = '0' + cp;
            }
            var id = marqueurs[i].getAttribute('magasin_id');
            var image = marqueurs[i].getAttribute('image');
            var horaire = marqueurs[i].getAttribute('horaire');
            var horaire_open_pause = (marqueurs[i].getAttribute('horaire_open_pause') != null ? marqueurs[i].getAttribute('horaire_open_pause') : '');
            var horaire_close_pause = (marqueurs[i].getAttribute('horaire_close_pause') != null ? marqueurs[i].getAttribute('horaire_close_pause') : '');
            var horaire_open = 0;
            var horaire_close = 0;
            var horaire_close_pause_string = '';
            var horaire_open_pause_string = '';

            if (marqueurs[i].getAttribute('horaire_open') != null && marqueurs[i].getAttribute('horaire_open') != '') {
                horaire_open = marqueurs[i].getAttribute('horaire_open').replace(/:/g, '');
                horaire_close = marqueurs[i].getAttribute('horaire_close').replace(/:/g, '');
                var horaire_open_string = marqueurs[i].getAttribute('horaire_open').replace(":", "h");
                var horaire_close_string = marqueurs[i].getAttribute('horaire_close').replace(":", "h");

                if (horaire_close_pause !== "" && horaire_open_pause !== "") {
                    horaire_close_pause = marqueurs[i].getAttribute("horaire_close_pause").replace(/:/g, '');
                    horaire_open_pause = marqueurs[i].getAttribute("horaire_open_pause").replace(/:/g, '');
                    horaire_close_pause_string = marqueurs[i].getAttribute('horaire_close_pause').replace(":", "h");
                    horaire_open_pause_string = marqueurs[i].getAttribute('horaire_open_pause').replace(":", "h");
                }
            }

            var currently_open = 0;
            if (parseInt(horaire_open) < parseInt(time) && parseInt(time) < parseInt(horaire_close)) {
                currently_open = 1;
            }
            var horaire_today = marqueurs[i].getAttribute('horaire_today');
            // A permanently closed store takes priority over any weekly/exceptional opening hours.
            if (marqueurs[i].getAttribute('closed') === '1') {
                currently_open = 0;
                horaire_today = Translator.translate('store_closed_permanently');
            } else if (!horaire) {
                // Si jamais le magasin est fermé
                horaire_today = "";
            } else if (horaire && !currently_open) {
                horaire_today = close_txt;
            } else {
                if (horaire_open_string && horaire_close_string) {
                    if (horaire_close_pause !== '' && horaire_open_pause !== '') {
                        horaire_today = store_open_until_3a + horaire_open_string + store_open_until_3b + horaire_close_pause_string + store_open_until_3d +
                        horaire_open_pause_string + store_open_until_3b + horaire_close_string;
                    } else {
                        horaire_today = store_open_until_2.replace(/\%s/, horaire_close_string);
                    }
                }
            }

            var horaire_plus = marqueurs[i].getAttribute('horaire_plus');
            if (horaire_plus) {
                horaire += '<span class="horaire_plus" style="display: none;">' + horaire_plus + '</span>';
            }

            if (marqueurs[i].getAttribute('holiday') !== '')
                horaire += '<br>' + marqueurs[i].getAttribute('holiday');
            var url = marqueurs[i].getAttribute("url");
            var telephone = marqueurs[i].getAttribute('tel');
            var email = marqueurs[i].getAttribute('email');
            var site = marqueurs[i].getAttribute('site');
            var magasin_type = marqueurs[i].getAttribute('magasin_type');
            var flag_available = marqueurs[i].getAttribute('flag_available');
            var lat = parseFloat(marqueurs[i].getAttribute("lat"));
            var lng = parseFloat(marqueurs[i].getAttribute("lng"));
            var special_open = '';
            if (marqueurs[i].getAttribute('holiday') !== '')
                special_open += marqueurs[i].getAttribute('holiday');

            var distance = 0;
            if (marqueurs[i].getAttribute('distance')) {
                var distance = parseFloat(marqueurs[i].getAttribute('distance'));
            }

            // Filter Boutiques
            var shop_filter = "";
            if (marqueurs[i].getAttribute("filtres").length) {
                shop_filter = marqueurs[i].getAttribute("filtres");
            }

            var horaire_formatted = marqueurs[i].getAttribute("horaire_formatted");
            /* if (horaire_formatted != "") {
                horaire_today = horaire_formatted;
            } */

            var point = new google.maps.LatLng(parseFloat(marqueurs[i].getAttribute('lat')), parseFloat(marqueurs[i].getAttribute('lng')));

            var marqueur = creerMarqueur(point, nom, adresse, ville, cp, pays, horaire, telephone, email, site, image, magasin_type, (i + 1), id, url, distance, currently_open, horaire_today);
            var nouvelleLigneListe = creerLigneListe((i + 1), id, nom, adresse, ville, cp, pays, currently_open, horaire_today, distance, marqueur, picture_filtre, magasinId, stock, stockStatus, stock_quantity, clientId, favorite, beContacted, flag_available, url, shop_filter, telephone, query, lat, lng, horaire_plus, email, horaire, special_open);
            listeLaterale.appendChild(nouvelleLigneListe);

            markers.push(marqueur);
            rectangleMarqueurs.extend(point);

            if ($('#pdvBox').is(":visible")) {

                $('#pdvBox').addClass('deployed');
            }

            var evt = new CustomEvent('storeListComplete');
            window.dispatchEvent(evt);
        }
        if (document.querySelector("body.mobile .elem_list_contents")){
            showStoreAll()
        }

        $('#store-nbr').html(marqueurs.length + ' ' + Translator.translate('result_store_found'));

        if (maCarte) {

            if ($("#retailers_map").length) {

                var myOptions = {
                    mapId: google_map_id
                };
                var mcOptions = {
                    gridSize: 80,
                };

                if (typeof MapsProviderService != "undefined") {
                    var mapHtml = document.getElementById('retailers_map');
                    maCarte = MapsProviderService.initSearchShopPage(mapHtml);
                } else {
                    maCarte = new google.maps.Map(document.getElementById("retailers_map"), myOptions);
                }
                clusterer = new markerClusterer.MarkerClusterer({
                    map: maCarte,
                    markers: markers,
                    options: mcOptions,
                    renderer: clustererRenderer
                });

                boundChanched(maCarte, markersArray);
                markers = [];
            }

            // On centre la carte sur la France sans cacher la Guadeloupe quand la france est choisie (default : initialisation ou choix)
            if (document.getElementById('search_pays').value === 'France' && document.getElementById('search_cp').value === '') {
                var latlng = new google.maps.LatLng(46.864716, 2.2);
                maCarte.setZoom(5);
                maCarte.setCenter(latlng);
            } else {
                // On recentre sur la base des marqueurs retorouvés
                maCarte.setCenter(rectangleMarqueurs.getCenter(), maCarte.fitBounds(rectangleMarqueurs));
            }

            if (marqueurs.length === 1)
                maCarte.setZoom(16);
        }

        displayLoader('show');

    });

}

// Removes the overlays from the map, but keeps them in the array
function clearOverlays() {

    var length_marker = markersArray.length;
    for (var i = 0; i < length_marker; i++) {
        markersArray[i].setMap(null);
    }
    markersArray.length = 0;

}

/*
 * type_call : auto (cas chargement premiere fois), button (recherche)
 */
function downloadUrl(url, rayon, type_call, callback) {
    var param_sup = '&rayon=' + rayon;
    var request = window.ActiveXObject ?
        new ActiveXObject('Microsoft.XMLHTTP') :
        new XMLHttpRequest;

    request.onreadystatechange = function () {
        if (request.readyState === 4) {
            request.onreadystatechange = doNothing;
            var marqueurs = request.responseXML.documentElement.getElementsByTagName("marqueur");
            if (marqueurs.length > 0) {
                callback(request, request.status);
            } else if (rayon === '100km') {
                downloadUrl(url, '300km', type_call, callback);
            } else {
                callback(request, request.status);
            }
        }
    };

    request.open('GET', url + param_sup, true);
    request.send(null);
}

function doNothing() {}

/**
 * Displays or hides the loader based on the given type.
 * @param {string} type - The type of action to perform on the loader. Possible values are 'hide' or any other value to display the loader.
 */
function displayLoader(type) {
    let loader = document.querySelector(".img-loader-container");
    if (loader !== null && loader !== undefined) {
        if (type === 'hide') {
            loader.style.display = "flex"
        } else {
            loader.style.display = "none"
        }
    }
}

/*
 * Utiliser lors de la soumission de la recherche des magasins (search_shop et fiche produit (ou trouver en magasin))
 */
function submitGeoloc() {

    if ($('#pdvBox').is(":visible")) {
        var product_ref = $('#produit_ref').val();
    }
    initSearch();
    geocodeAdresse();

    return false;
}

var url_string = window.location.href;
var url = new URL(url_string);
var openLightboxParam = url.searchParams.get("open");
if (openLightboxParam && openLightboxParam == '1') {
    showpdv();
}

// popup PDV
function showpdv() {
    var shade, modbox;
    $.ajax({
        type: "post",
        url: path_relative_root + "ajax-distributeurs.php",
        success: function (res) {
            if (res) {
                shade = document.querySelector("#shad.modal_shade");
                modbox = document.getElementById("pdvBox");

                // Make sure modbox will show on top of shad
                $(shade).after(modbox);

                // Inject store locator into modbox
                $(".store_locator").html(res);

                // magasin_gmap.js
                initialize();

                // Show modbox and make sure closing routine won't fire more than once

                $(shade).off('click', closepdv);
                $(modbox).addClass('deployed');
                $(shade).addClass('actif');
                $(shade).on("click", closepdv);
                $("html, body").animate({scrollTop: 0}, 500);
                $("#pdv_load").removeClass("loading");
            }
        },
    });
}

function closepdv(from) {

    var shade = document.querySelector("#shad.modal_shade");
    var modbox = document.getElementById('pdvBox');

    $(modbox).removeClass('deployed');
    $(shade).removeClass('actif');

    $(shade).off('click', closepdv);

    if (from == 'fiche produit' || $("body.product_page").length) {
        setTimeout(function () {
            $('#content_pdvBox_new').hide();
            $('#content_pdvBox').show();
            $(modbox).removeClass('showForm');
            $(modbox).removeClass('thanks');
        }, 200);
    }
}

function addToMyFavorite(magasin_id, client_id, favorite, info_horaire_today, currently_open, horaire_today, class_horaire_today, stock, stockStatus) {
    event.preventDefault();
    if (client_id == 0) {
        var connect_link = path_relative_root + create_link('connexion_login');
        alert('<div class="box_txt_wishlist selected_mag"><h2>' + Translator.translate('add_store_login_error_title') + '</h2><br>' + Translator.translate('add_store_login_error_text') + '<br><button class="button primary" onclick="favStoreRedirectLogin()">' + Translator.translate('vgt_connexion') + ' </button></div>');
    } else {
        if (favorite == 0) {
            var act = 'add';
        } else {
            var act = 'del';
        }

        $.ajax({
            url: path_relative_root + 'ajax_manage_favorite_store.php',
            type: 'post',
            dataType: 'html',
            data: 'act=' + act + '&magasin_id=' + magasin_id + '&client_id=' + client_id,
            success: function (response) {
                response = JSON.parse(response);
                var getCustomerFavoriteStore = document.querySelector('#customerFavoriteStore');
                var customerFavoriteStore = false;
                if (getCustomerFavoriteStore) {
                    customerFavoriteStore = customerFavoriteStore.value
                }
                var shopName = document.querySelector('.mag_name_fav');
                var shopStock = document.querySelector('.mag_stock_fav');
                var shopHours = document.querySelector('.mag_hours');
                var shopTown = document.querySelectorAll('.mag_ville');
                var shopStreet = document.querySelector('.mag_rue');
                var shopCountry = document.querySelector('.mag_pays');
                var shopCp = document.querySelector('.mag_cp');

                var noStoreSelected = document.querySelector('#no_store_selected');
                var noStoreSelectedHidden = document.querySelector('#no_store_selected_hidden');

                var shopList = document.querySelector('.liste_distributeur');
                var storeMoreLink = document.querySelector('.store_more');

                var customerHeartFav = document.querySelector('#heartFav-' + magasin_id);
                var allHeartFav = document.querySelectorAll('.heartFav');

                var currentFavStore = document.querySelector('#currentFavStore');
                var hiddenProductFavStore = document.querySelector('#hiddenProductFavStore');
                var noFavShop = document.querySelector('#noFavShop');

                if (allHeartFav) {
                    for (var i = 0; i < allHeartFav.length; i++) {
                        allHeartFav[i].className = "heartFav";
                    }
                }
                if (hiddenProductFavStore && noFavShop) {
                    noFavShop.style.display = "none";
                    hiddenProductFavStore.style.display = "flex";
                }

                if (customerHeartFav) {
                    customerHeartFav.className = "heartFav";
                    customerHeartFav.className = "selected";
                }

                if (shopList) {
                    shopList.className += " withfav";
                }
                if (noStoreSelected && noStoreSelectedHidden && !currentFavStore) {
                    noStoreSelected.style.display = "none";
                    noStoreSelectedHidden.style.display = "block";
                }

                if (shopName) {
                    shopName.innerHTML = response.store.magasin_nom;
                }

                if (shopTown) {
                    for (var i = 0; i < shopTown.length; i++) {
                        var town = shopTown[i];
                        town.innerHTML = response.store.magasin_ville;
                    }
                }
                if (shopStreet) {
                    shopStreet.innerHTML = response.store.magasin_adresse;
                }
                if (shopCp) {
                    shopCp.innerHTML = response.store.magasin_cp;
                }
                if (shopCountry) {
                    shopCountry.innerHTML = response.store.magasin_pays;
                }
                if (stock != "null") {
                    shopStock.innerHTML = Translator.translate(stock.slice(0, -3));
                    shopStock.setAttribute('data-status', stockStatus);
                }

                if (shopHours) {
                    if ((info_horaire_today !== '' && currently_open) || (!currently_open && horaire_today)) {
                        shopHours.innerHTML = '<span class="horaire-today"><span class="puce ' + unescape(class_horaire_today) + '"></span> ' + unescape(info_horaire_today) + '</span>';
                    } else {
                        shopHours.innerHTML = "";
                    }
                }

                var storeClient = document.getElementById('favShop-' + magasin_id);
                var allStore = document.getElementsByClassName('choose_fav_label');
                var countAllStore = allStore.length;

                for (var i = 0; i < countAllStore; i++) {
                    allStore[i].innerHTML = '<span class="bgSprite bfr store"></span><span>' + Translator.translate('choose_as_favorite_store') + '</span>';
                }

                if (response.status == "add") {
                    storeClient.innerHTML = '<span class="bgSprite bfr store"></span><span>' + Translator.translate('actual_favorite_store') + '</span>';
                } else if (response.status == "delete") {
                    storeClient.innerHTML = '<span class="bgSprite bfr store"></span><span>' + Translator.translate('choose_as_favorite_store') + '</span>';
                }

                if ($('#pdvBox').length) {

                    closepdv();
                    location.reload();
                }
            }
        });
    }
    return false;
}

function favStoreRedirectLogin() {
    $.get(path_relative_root + "redirect_after_login_favorite_store.php", function () {
        document.location.href = path_relative_root + create_link('connexion_login') + "?from=front";
    });
}

function handleChange (id, nom) {
    var locator = document.getElementById('content_pdvBox');
    $(locator).hide();

    if(sessionStorage.pvdcontent) {
        $('#content_pdvBox_new').html(sessionStorage.pvdcontent);
        $('#content_pdvBox_new').addClass(sessionStorage.pvdclass);
    }

    var formulaire = document.getElementById('content_pdvBox_new');
    $(formulaire).find('#message').children('#nom_magasin').html(nom);
    document.getElementById('id_magasin_form').setAttribute('value',id);
    var modbox = document.getElementById('pdvBox');
    $(modbox).addClass('showForm');

    if (!$(modbox).hasClass('sidebox')) {
        $(modbox).animate({
            maxHeight : '100%',
            overflow : "auto"
        }, 1000);
    }

    $(formulaire).show();

    setTimeout(function() {
        if(!sessionStorage.pvdcontent) {
            setTimeout(function() {
                sessionStorage.pvdcontent = $('#content_pdvBox_new').html();
                sessionStorage.pvdclass = $('#content_pdvBox_new').attr("class");
            }, 100);
        }
    }, 100);

    if (typeof initContentPDVBoxNewForm === 'function') {
        setTimeout(function() {
            initContentPDVBoxNewForm(true);
        }, 400);
    }
}

function boundChanched(maCarte, markersArray) {
    google.maps.event.addListener(maCarte, 'bounds_changed', function(event) {
        var bounds = maCarte.getBounds();

        if (bounds !== undefined && bounds) {
            var nb_shown_shops = 0;
            $(".elem-list-store").hide();

            for (var i = 0; i < markersArray.length; i++) {
                var marker = markersArray[i];
                var marker_magasin_id = marker.magasin_id;

                if (bounds.contains(marker.position)) {
                    $('#' + marker_magasin_id).show(); // Display the given store entry in the list
                    nb_shown_shops++;
                }
            }
            $('#store-nbr').html(nb_shown_shops  + ' ' + Translator.translate('result_store_found'));
        }
    });
}

// mobile modale contact_mag

function handleChangeMobile(id) {
    var formStore = document.querySelector(".formStore")
    var inputMagId = formStore.querySelector("#id_magasin_form")
    var shad = document.querySelector("#shade")
    inputMagId.value = id
    formStore.classList.remove("cache")
    formStore.classList.remove("thanks")
    openMultiShad("shade")
    shad.classList.add("contact_mag")
    shad.addEventListener("click", closeModalContactMagMobile)

    if ($("#clientTel").length) {
        $('#clientTel').intlTelInput();
    }
}

function closeModalContactMagMobile(){
    var formStore = document.querySelector(".formStore")
    var shad = document.querySelector("#shade")
    formStore.classList.add("cache")
    shad.classList.add("contact_mag")
    closeMultiShad("shade")
    shad.removeEventListener("click", closeModalContactMagMobile)
}
/**
 * Pour géolocaliser le lieux en fonction de la latitude et de la longitude
*/
function geolocGoto(lat, lng) {
    var latlng = new google.maps.LatLng(lat, lng);

    // On centre la carte suivant les marqueurs trouves
    maCarte.setCenter(latlng);
    maCarte.setZoom(15);

    $("html, body").animate(
        {
            scrollTop:
                $("#retailers_map").offset().top -
                $("#site_head_wrap").height(),
        },
        500
    );
    boundChanched(maCarte, markersArray);
}

// btn "SEE MORE"
var storeNbrDisplayed = 4;
var increaseNbr = 4;

$(document).on('click', '#showMore', function (e) {

    resetResults = false;
    showAllStoreBtn = false;
    e.preventDefault();
    storeNbrDisplayed += increaseNbr;
    showStoreAll();
});

$(document).on('click', '#showAll', function () {

    showAllStoreBtn = true;
    resetResults = true;

    if ($('#search_pays').length) {

        resetSelectedCountry();
    }

    if ($('#search_cp').val() !== '') {

        $('#search_cp').val('');
    }

    displayLoader('hide');
    setTimeout(function () {
        rechercheProximite();
    }, 500);
});

function showStoreAll() {

    if (resetResults === true) {
        storeNbrDisplayed = 4;
    }

    var tabStore = document.querySelectorAll(".elem-list-store");
    var showNbrStore = showAllStoreBtn ? tabStore.length : storeNbrDisplayed;

    for (var i = 0; i < tabStore.length; i++) {

        if (showNbrStore <= i) {

            break
        }

        const store = tabStore[i];
        store.classList.add("show-store");
    }

    if (storeNbrDisplayed >= tabStore.length && !document.querySelector("#showMore").classList.contains("disable")){

        document.querySelector("#showMore").classList.add("all-store-visible");
    } else if ((storeNbrDisplayed <= tabStore.length && !document.querySelector("#showMore").classList.contains("disable"))){

        document.querySelector("#showAll").classList.remove("all-store-visible");
        document.querySelector("#showAll").classList.remove("disable");
        document.querySelector("#showMore").classList.remove("all-store-visible");
        document.querySelector("#showMore").classList.remove("cache");
    }

    if (showAllStoreBtn === true) {
        document.querySelector("#showAll").classList.add("all-store-visible");
        document.querySelector("#showMore").classList.add("all-store-visible");
    }
}
